import React, { useEffect, useCallback } from 'react'
import ReactDOM from 'react-dom'

import styles from './Lightbox.module.scss'

interface LightboxProps {
  url: string
  type: 'image' | 'video'
  onClose: () => void
}

export default function Lightbox({ url, type, onClose }: LightboxProps) {
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose()
      }
    },
    [onClose]
  )

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [handleKeyDown])

  return ReactDOM.createPortal(
    <div className={styles.Lightbox} onClick={onClose}>
      <div className={styles.Lightbox__content} onClick={e => e.stopPropagation()}>
        <button className={styles.Lightbox__close} onClick={onClose}>
          <i className="pi pi-times" />
        </button>
        {type === 'video' ? <video src={url} controls autoPlay muted /> : <img src={url} alt="Preview" />}
      </div>
    </div>,
    document.body
  )
}
